module.exports = "<div id=\"edit-map\" (resized)=\"onResized($event)\"></div>"